
import { useState } from "react";
import { useSprings, animated, to as interpolate } from "@react-spring/web";
import { useDrag } from "react-use-gesture";

import { WindowSize } from "react-fns";
import useWindowDimensions from "../../utils/useWindowDimensions";

import { makeStyles } from "@material-ui/core/styles";

import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import { withStyles } from "@material-ui/core/styles";

// import { Link } from "@material-ui/core";
// import { Typography } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import IconButton from "@material-ui/core/IconButton";

//9by16 images as backgrounds for cards
import medrink from "../images/animateddeck/medrink169.jpg";
import prod from "../images/animateddeck/prodlogos.png";
import pm from "../images/animateddeck/pm1.jpg";
import uc from "../images/animateddeck/g1.jpg";
import ut from "../images/animateddeck/utx.jpg";
import houston from "../images/animateddeck/houston169.jpg";

//icons for cards
import passion from "../images/animateddeck/icons/heart.png";
import eth from "../images/animateddeck/icons/eth.png";
import concensys from "../images/animateddeck/icons/concensys.jpg";

import bulb from "../images/animateddeck/icons/bulb.png";
import yclogo from "../images/animateddeck/icons/yc.png";

import pmlogo from "../images/animateddeck/icons/pmtire.png";
import pmp from "../images/animateddeck/icons/pmp.jpg";
import briefcase from "../images/animateddeck/icons/bcase.png";

import ucsblogo from "../images/animateddeck/icons/ucsblogo.png";
import master from "../images/animateddeck/icons/master.jpg";

import longhorn from "../images/animateddeck/icons/longhorns.png";
import bachelor from "../images/animateddeck/icons/bachelor.jpg";

import house from "../images/animateddeck/icons/house.png";
import flex from "../images/animateddeck/icons/flex.png";

//-----------------------------------------//
//these are the 16x9 vertical card images ordered from bottom to top shown on deck
const cards = [medrink, prod, pm, uc, ut, houston];

//these are the icons for each card, they must be ordered in the same order as their parent cards
const icons = [
  [
    {
      image: passion,
      tooltip:
        "Been closely following crypto since early 2017, I could no longer just observe and invest, and have been in the past year diving in building decentralized apps!",
      link: "",
    },
    { image: concensys, tooltip: "Concensys Bootcamp", link: "" },
    { image: eth, tooltip: "dApp projects", link: "" },
  ],
  [
    { image: bulb, tooltip: "5 years of experience building products QQ, Cider, and Kaura", link: "" },
    {
      image: yclogo,
      tooltip: "Completed YC Startup School",
      link: "https://www.startupschool.org/users/V44VXGAIr/certificate",
    },
  ],
  [
    {
      image: pmlogo,
      tooltip: "Which swing did you want?",
      link: "https://knowyourmeme.com/memes/tree-swing-cartoon-parodies",
    },
    {
      image: pmp,
      tooltip: "Project Management Professional (PMP) Certified",
      link: "https://www.pmi.org/certifications/certification-resources/registry",
    },
    {
      image: briefcase,
      tooltip:
        "I have 10 years of experience managing projects ranging from process improvements, CRM implementations, to custom web apps. Adept with both waterfall and agile methodoligies such as Scrum and Kanban.",
      link: "",
    },
  ],
  [
    { image: ucsblogo, tooltip: "UC Santa Barbara", link: "" },
    { image: master, tooltip: "Received Master of Science in Electrical and Computer Engineering", link: "" },
  ],
  [
    { image: longhorn, tooltip: "The University of Texas at Austin", link: "" },
    { image: bachelor, tooltip: "Received Bachelor of Science in Electrical Engineering", link: "" },
  ],

  [
    {
      image: house,
      tooltip: "I currently live in Houston with my amazing, easy to love, and supportive family.",
      link: "",
    },
    {
      image: flex,
      tooltip:
        "Ideally, I would like to work remotely, but am flexible to move to major hubs like the Bay Area or Austin.",
      link: "",
    },
  ],
];

const useStyles = makeStyles((theme) => ({
  avatarbox: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
    position: "absolute",
    bottom: "2.9%",
    //background: "black",
    //backgroundColor:"rgba(0, 0, 0, 0.4)",
    borderRadius: "0px",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    boxShadow: theme.shadows[10],
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: theme.shadows[15],
    },
  },
  linktext: {
    //need to match MyToolTip style
    fontSize: 20,
  },
}));

//tooltips tyles guide https://blog.devgenius.io/material-ui-tooltips-c2c9c1314a43
const MyTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    boxShadow: theme.shadows[10],
    fontSize: 20,
    textAlign: "center",
    maxWidth: 300,
    borderRadius: "10px",
  },
  arrow: {
    color: theme.palette.primary.main,
    boxShadow: theme.shadows[0],
  },
}))(Tooltip);

//-----------------------------------------------------------//
// These two are just helpers, they curate spring data, values that are later being interpolated into css
const to = (i) => ({ x: 0, y: i * -4, scale: 1, rot: -10 + Math.random() * 20, delay: i * 100 });
const from = (i) => ({ x: 4000, rot: 0, scale: 1.1, y: 0 }); //defines the initial values on load
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const myconfigs = (i) => ({ mass: 1, tension: 170, friction: 100 }); //can customize config object here https://react-spring.io/common/configs
const trans = (r, s) => `perspective(2000px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`;
//----------------end of animation code-----------------------//

const AnimatedDeck = () => {
  const classes = useStyles(); //for material ui avatars

  const { width } = useWindowDimensions(); //on render gets the window size then cleanup the check, this is addressed inside the hook
  //use this value to determine one top or not.

  //-----------Start of animation code---------------------//
  const [gone] = useState(() => new Set()); // The set flags all the cards that are flicked out. gone is initialized as a Set javascript object/primitive like.
  const [props, api] = useSprings( cards.length , (i) => ({ ...to(i), from: from(i), config: myconfigs(i) })); // Create a bunch of springs using the helpers above. updated second arg of returned array from set to api. Also replaced "set" in code below with "api.start" per https://react-spring.io/common/imperatives-and-refs
  

  const bind = useDrag(({ args: [index], down, movement: [mx], direction: [xDir], velocity, initial: [ix] }) => {
    //it is considered ondeck if initial touch of card is within the center radius
    const ondeck = Math.abs(ix - width / 2) < 300 ? true : false;

    const trigger = ondeck && velocity > 0.2 ? true : false; // If you flick hard enough it should trigger the card to fly out

    //the direction where the card will land is dtermines based on where the card is currently.
    let dir = 0;
    if (ondeck) {
      dir = xDir < 0 ? -1 : 1;
    } else if (!ondeck) {
      dir = xDir < 0 ? 1 : -1;
    }

    //const dir = xDir < 0 ? -1 : 1; // Direction should either point left or right/-determines where the card flies to

    if (ondeck && !down && trigger) gone.add(index); // If you're ondeck (aka NOT near the discard pile) and your button/finger's up and trigger velocity is reached, we flag the card ready to fly out

    //if (!ondeck && !down ) gone.add(index); //! not working If button/finger's up And card is draged out of screen near the discard pile , we also flag the card ready to fly out

    api.start((i) => {
      if (index !== i) return; // We're only interested in changing spring-data for the current spring
      const isGone = gone.has(index);

      //should do nothing if it is not ondeck?
      const x = ondeck ? (isGone ? 1400 * dir : down ? mx : 0) : 0; // When a card is gone it flys out left or right, otherwise (if it is down then x equal mx else if finger is up then goes goes back to zero). (window.innerWidth+200) instead of 800 makes it fly out of the (window.innerWidth + 200) more pixels. # here 800 is where the discard pile is from origine
      const rot = mx / 100 + (isGone ? dir * 10 * velocity : 0); // How much the card tilts, flicking it harder makes it rotate faster
      const scale = down ? 1.1 : 1; // Active cards lift up a bit
      return { x, rot, scale, delay: undefined, config: { friction: 50, tension: down ? 200 : isGone ? 200 : 200 } };
    });
    //reset the cards when out of cards
    if (!down && gone.size === cards.length) setTimeout(() => gone.clear() || api.start((i) => to(i)), 600);
  });

  const AnimatedBox = animated(Box);
  //----------------end of animation code-----------------------//
  /*
There are 2 AnimatedBoxes and a Wrapper around it to give it Sticky position placeholder so that the cards Take Up space, and push other contents of page correctly.
    It's width should match the width of AnimatedBoxOuter. It's height should be 100px more than AnimatedBoxOuter to give some margin on the bottom. maxheight of card
2. AnimatedBoxOuter can be used as the containers of the cards
3. AnimatedBoxInner the actual cards. the size of the cards is maxwidth and maxheight. responsive variable will control this. Remember to match to standard card playing ratios of w2.5 to 3.5
*/

  //layout with box https://smartdevpreneur.com/align-buttons-in-material-ui-using-the-box-component/

  //more with box: https://levelup.gitconnected.com/using-the-box-component-in-material-ui-to-easily-style-your-project-532894edd205

  return (
    <>
      <WindowSize
        render={({ width }) => {
          const cardWidth = width > 1280 ? 1280 * 0.16 + 180 : width * 0.16 + 180;
          const cardHeight = cardWidth * 1.7;
          return (
            <>
              <Grid container justifyContent='center' alignItems='center'>
                <Box
                  width={`${cardWidth}px`}
                  height={`${cardHeight + 100}px`}
                  display='flex'
                  justifyContent='center'
                  alignItems='start'
                  overflow='hidden'
                >
                  {/* Now we're just mapping the animated values to our view, that's it.*/}
                  {props.map(({ x, y, rot, scale }, i) => (
                    <AnimatedBox
                      key={i}
                      style={{
                        transform: interpolate([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`),
                        touchAction: "none",
                      }}
                      position='absolute'
                    >
                      {/* This is the card itself, we're binding our gesture to it (and inject its index so we know which is which) */}
                      <AnimatedBox
                        {...bind(i)}
                        style={{
                          transform: interpolate([rot, scale], trans),
                          backgroundImage: `url(${cards[i]})`,
                          backgroundPosition: "center",
                          backgroundSize: "90%",
                          backgroundRepeat: "no-repeat",
                          touchAction: "none",
                        }}
                        width={`${cardWidth}px`}
                        height={`${cardHeight}px`}
                        maxWidth={`${cardWidth}px`}
                        maxHeight={`${cardHeight}px`}
                        borderRadius={16}
                        boxShadow={15}
                        p={0}
                        bgcolor='info.main'
                        display='flex'
                        justifyContent='center'
                        alignItems='center'
                      >
                        <Box className={classes.avatarbox} width='90%'>
                          {icons[i].map((e, j) => (
                            <div key={j} onContextMenu={(e) => e.preventDefault()}>
                              <MyTooltip
                                arrow
                                placement='top'
                                TransitionComponent={Zoom}
                                enterTouchDelay={0}
                                leaveDelay={0}
                                leaveTouchDelay={1000}
                                interactive
                                title={
                                  <>
                                    {icons[i][j]["tooltip"]}

                                    <IconButton
                                      size='small'
                                      color='inherit'
                                      target='_blank'
                                      rel='noreferrer'
                                      href={icons[i][j]["link"]}
                                    >
                                      {icons[i][j]["link"] ? <OpenInNewIcon /> : ""}
                                    </IconButton>
                                  </>
                                }
                              >
                                <Avatar
                                  alt={icons[i][j]["tooltip"]}
                                  src={icons[i][j]["image"]}
                                  className={classes.avatar}
                                />
                              </MyTooltip>
                            </div>
                          ))}
                        </Box>
                      </AnimatedBox>
                    </AnimatedBox>
                  ))}
                </Box>
              </Grid>
            </>
          );
        }}
      />
    </>
  );
};

export default AnimatedDeck;
